import { useState } from "react";
import Box from "@mui/material/Box";
import { useFormContext } from "react-hook-form";
import { useTranslationApp } from "../../../lib/i18next";
import {
  COPY_VALUES_IN_OTHER_ADS,
  MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL,
} from "../../../i18n/keysTranslations";
import ClickableText from "../../Texts/ClickableText";
import ModalEditUrlParameters from "./ModalEditUrlParameters";
import { parseUtmString } from "./utils/utmParameters";
import TextField from "../../Form/TextField";
import { GOOGLE } from "../../../utils/constants";

const UtmParametersContainer = ({
  name,
  control,
  errors = {},
  disabled = false,
  platform,
  onCopyValuesInOtherAds,
  copyText = COPY_VALUES_IN_OTHER_ADS,
  googleUtmEntityFormPath,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslationApp();

  const {
    control: controlContext,
    setValue,
    watch,
    getValues,
  } = useFormContext();
  const finalControl = control || controlContext;

  const value = watch ? watch(name) || "" : "";

  const googleUtmNames =
    platform === GOOGLE && googleUtmEntityFormPath
      ? {
          campaignName:
            getValues(`platformsData.${GOOGLE}.name`) ||
            getValues("name") ||
            "",
          creativeName: getValues(`${googleUtmEntityFormPath}.name`) || "",
        }
      : undefined;

  const onToggleModal = () => setModalOpen((prev) => !prev);

  const parsedParams = parseUtmString(value);
  const totalParams = Object.keys(parsedParams).length;
  const hasValue = totalParams > 0;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <TextField
        name={name}
        variant="filled"
        fullWidth
        disabled={disabled}
        control={finalControl}
        errors={errors}
        rules={{ required: { value: false } }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          "@media (max-width: 600px)": {
            flexDirection: "column-reverse",
            gap: 1,
          },
        }}
      >
        {onCopyValuesInOtherAds && (
          <ClickableText disabled={disabled} onClick={onCopyValuesInOtherAds}>
            {t(copyText)}
          </ClickableText>
        )}
        <ClickableText
          disabled={disabled}
          onClick={onToggleModal}
          sx={{ color: "text.secondary" }}
        >
          {t(MODAL_EDIT_URL_PARAMETERS_BUILD_LABEL)}
          {hasValue ? ` (${totalParams})` : ""}
        </ClickableText>
      </Box>

      {modalOpen && (
        <ModalEditUrlParameters
          modalOpen={modalOpen}
          onCloseModal={onToggleModal}
          currentValue={value}
          platform={platform}
          googleUtmNames={googleUtmNames}
          onApply={(utmString) => {
            setValue(name, utmString);
          }}
        />
      )}
    </Box>
  );
};

export default UtmParametersContainer;
